import { UnderDevelopment } from '../../../utils/UnderDevelopment/UnderDevelopment';
import './TenantResource.scss';

export const TenantResource = () => {
  return (
    <UnderDevelopment />
  );
};
